export const TERMS_TYPES = {
  CREATE_TERM: 'terms/createTerm',
  FETCH_TERMS: 'terms/fetchTerms',
};
